'use client';

import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useEffect, useState } from 'react';
import { BUNDLE_CHOICE_OPTIONS } from '../global-constants';
export default function useSoftBundles(featureFlag, cookieValue) {
  var rooms = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  var children = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isSoftBundlesVisible = _useState2[0],
    setIsSoftBundlesVisible = _useState2[1];
  useEffect(() => {
    var isEnabled = featureFlag && rooms === 1 && children === 0 && (cookieValue === BUNDLE_CHOICE_OPTIONS.class || cookieValue === BUNDLE_CHOICE_OPTIONS.rate || cookieValue === BUNDLE_CHOICE_OPTIONS.roomOnly);
    setIsSoftBundlesVisible(isEnabled);
  }, [featureFlag, cookieValue, rooms, children]);
  return {
    isSoftBundlesVisible,
    softBundle: cookieValue
  };
}